export const stringToInline = (str: string) => str.toLowerCase().replace(/ /g, '-')
